import { render, staticRenderFns } from "./MerchantInfo.vue?vue&type=template&id=34b27f3d"
import script from "./MerchantInfo.vue?vue&type=script&lang=js"
export * from "./MerchantInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports